import React from "react";
import { View, Text, ScrollView } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { Image } from "expo-image";
import Images from "@/assets/images";
import FlightCard from "./FlightCard";
import { FontFamilies, Typography } from "@/constants/Typography";
import Icons from "@/assets/icons";

export default function WelcomeSlide6() {
  return (
    <ScrollView
      style={styles.container}
      contentContainerStyle={styles.contentContainer}
      showsVerticalScrollIndicator={false}
    >
      {/* Title */}
      <Text style={styles.title}>Negotiate your bills using AI.</Text>
      {/* Card */}
      <FlightCard
        title={"June electricity bill"}
        logo={<Image source={Images.unclaimedTemplate} style={styles.logo} />}
        status={[
          {
            icon: <Icons.SearchCircle />,
            text: "Get refunds on late deliveries from Uber, food delivery, and online stores",
          },
        ]}
      >
        <Text style={styles.cardLabel}>NEGOTIATE BILLS</Text>
      </FlightCard>
      {/* Review box */}
      <View style={styles.reviewBox}>
        <Image source={Images.avatarRv6} style={styles.avatar} />
        <View style={styles.reviewContent}>
          <Text style={styles.stars}>★★★★★</Text>
          <Text style={styles.reviewText}>
            @your.mane.girrl: &quot;This is the easiest process ever they put
            all the available class actions in one place.&quot;
          </Text>
        </View>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentContainer: {
    flexGrow: 1,
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontFamily: FontFamilies.InterTight.Medium,
    fontSize: 36,
    color: "#fff",
    textAlign: "left",
    width: "100%",
    paddingHorizontal: 16,
    marginBottom: 24,
  },
  cardLabel: {
    color: "#fff",
    fontFamily: FontFamilies.InterTight.Medium,
    fontSize: 10,
    marginBottom: 4,
  },
  logo: {
    width: 120,
    height: 100,
  },
  reviewBox: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "rgba(255,255,255,0.08)",
    borderRadius: 16,
    padding: 12,
    marginTop: 24,
    width: "90%",
    borderWidth: 1,
    borderColor: "#FFFFFF33",
  },
  avatar: {
    width: 36,
    height: 36,
    borderRadius: 18,
    marginRight: 12,
  },
  reviewContent: {
    flex: 1,
  },
  stars: {
    color: "#FFD700",
    ...Typography.body.medium,
    marginBottom: 2,
  },
  reviewText: {
    color: "#fff",
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 13,
  },
});
